import * as React from "react";

import Navigation from "./nav";
import Logo from "./logo";

const Header = ({ setShowSidbarMarginLeft, showSidbarMarginLeft }) => {
  return (
    <div className=" text-white  bg-gradient-to-t from-[#faf838] via-transparent to-transparent   ">
      <div>
        <Navigation
          setShowSidbarMarginLeft={setShowSidbarMarginLeft}
          showSidbarMarginLeft={showSidbarMarginLeft}
        />
      </div>
      <div className="">
        <Logo showSidbarMarginLeft={showSidbarMarginLeft} />
      </div>
    </div>
  );
};

export default Header;
